// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2LcS-","col":"Table_col__7riYi","fulfillmentStatus":"Table_fulfillmentStatus__37aZW","emailCol":"Table_emailCol__1qNgG"};